import { RouteLocationNormalized } from 'vue-router'
import Urls from '@/lib/urls'
import store from '@/store'
import userGetters from '@/store/userModule/getterTypes'

const REDIRECT_URI = Urls.app('/dashboard')

export const applyAuthenticatedRedirects = (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized
) => {
  if (to.meta?.redirectIfAuthenticated) {
    const user = store.getters[userGetters.USER.NAMESPACED]

    if (user) {
      const query = to.fullPath.includes('?')
        ? `?${to.fullPath.split('?')[1]}`
        : ''

      // @ts-ignore
      window.location = `${REDIRECT_URI}${query}`
      return false
    }
  }

  return true
}

export default applyAuthenticatedRedirects
